export default __webpack_public_path__ + "static/media/googleIcon.7ed7a5ea.png";